import React from "react";
import CartVerificationDashboard from "./components/CartVerificationDashboard";
import PrescribedDiagnosticsScreen from "./components/PrescribedDiagnosticsScreen";
import DocumentUpload from "../navigo-module/components/DocumentUpload";

class CartModule extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      view: 0,
      props: null,
      dashboardKey: 0,
      dashboardKeyReload: 0,
      // Bumped on every navigation into the diagnostics screen (view 1) so the
      // screen remounts and re-runs its init cascade. Needed for screen→screen
      // jumps (e.g. Reorder opens a brand-new cart while already on view 1),
      // where changing props alone would not re-trigger the mount effect.
      screenKey: 0,
      // The patient selected in the CREATE flow, hoisted out of the screen so it can be part
      // of the screen's React key. A new patient therefore REMOUNTS the diagnostics screen
      // rather than trying to scrub ~30 pieces of state back to their initial values.
      //
      // This is a data-integrity boundary. The screen holds the previous patient's documents,
      // cart id, provider list and several refs; anything left behind gets written back under
      // the NEW patient (the backend does not validate document ownership). A remount cannot
      // leak by construction, which a manual reset can only approximate.
      cartPatient: null,
    };
  }

  // Called by the diagnostics screen whenever the operator picks or clears a Patient ID.
  setCartPatient = (patient) => this.setState({ cartPatient: patient });

  setView = (v, p) => {
    this.setState((prev) => ({
      view: v,
      props: p,
      screenKey: v === 1 ? prev.screenKey + 1 : prev.screenKey,
      // Entering the detail screen afresh must never inherit the previous visit's patient.
      cartPatient: v === 1 ? null : prev.cartPatient,
      // Reload the dashboard when returning to it from DocumentUpload (view 2),
      // so any data changed during upload is reflected.
      dashboardKeyReload:
        prev.view === 2 && v === 0
          ? prev.dashboardKeyReload + 1
          : prev.dashboardKeyReload,
    }));
  };
  resetDashboard = () => {
    this.setState((prev) => ({ dashboardKey: prev.dashboardKey + 1 }));
  };
  resetDashboardReload = () => {
    this.setState((prev) => ({
      dashboardKeyReload: prev.dashboardKeyReload + 1,
    }));
  };

  render() {
    return (
      <>
        <div style={{ display: this.state.view === 0 ? "block" : "none" }}>
          <CartVerificationDashboard
            key={this.state.dashboardKey}
            setView={this.setView}
            data={this.state.props}
            history={this.props.history}
            dashboardKeyReload={this.state.dashboardKeyReload}
          />
        </div>
        {this.state.view === 1 ? (
          <PrescribedDiagnosticsScreen
            key={`${this.state.screenKey}:${this.state.cartPatient?.id ?? "none"}`}
            initialPatient={this.state.cartPatient}
            onPatientChange={this.setCartPatient}
            setView={this.setView}
            data={this.state.props}
            resetDashboard={this.resetDashboard}
            resetDashboardReload={this.resetDashboardReload}
          />
        ) : this.state.view === 2 ? (
          <DocumentUpload
            setView={this.setView}
            data={this.state.props}
            resetDashboardReload={() => {}}
          />
        ) : (
          <></>
        )}
      </>
    );
  }
}

export default CartModule;
